module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-shock-smiley-svgrepo-com.e02f89bf.svg";